<template>
  <v-container>
    <view-intro heading="Багшийн xичээлүүд" />
    <v-row>
      <v-col cols="6">
        <v-select
          v-if="semesters"
          :items="semesters"
          return-object
          item-text="name"
          item-value="id"
          v-model="selectedSemester"
        ></v-select>
      </v-col>
    </v-row>
    <teacher-lesson-table
      v-if="selectedSemester && selectedSemester.lessons"
      :lessons="selectedSemester.lessons"
      :schoolPath="yyschool"
      :semester="selectedSemester"
      :needToConfirmed="true"
    ></teacher-lesson-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    selectedSemester: null,
    schools: null,
    semesters: null,
  }),
  components: {
    TeacherLessonTable: () => import("./TeacherLessonTable"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    console.log(this.userProfile);
    this._setupp();
  },

  methods: {
    _setupp() {
      console.log(
        this.yyschool + "/xschoolyears/uMebIxxLcBmCe9KeEWpT/semesters"
      );
      fb.db
        .collection(
          this.yyschool + "/xschoolyears/uMebIxxLcBmCe9KeEWpT/semesters"
        )
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          {
            this.semesters = [];

            querySnapshot.forEach((doc) => {
              let semester = doc.data();
              semester.id = doc.id;
              semester.ref = doc.ref;
              semester.lessons = null;
              semester.name =
                semester.startDate +
                " / " +
                semester.endDate +
                " /" +
                semester.shortName +
                "/";
              var query = fb.db
                .collection(this.yyschool + "/lessons")
                .where("semesterRef", "==", semester.ref)
                .orderBy("createdAt", "desc");
              if (this.userProfile.role == "teacher") {
                query = query.where("teacherRef", "==", this.userProfile.ref);
                console.log(this.userProfile.ref.path);
              }

              query.onSnapshot((querySnapshot) => {
                semester.lessons = [];
                var counter = 0;
                querySnapshot.forEach((doc) => {
                  counter++;
                  let lesson = doc.data();
                  lesson.ref = doc.ref;
                  lesson.id = doc.id;
                  lesson.index = counter;
                  lesson.lessonStandard2 = null;
                  if (lesson.lessonStandardRef) {
                    lesson.lessonStandardRef.get().then((lessonStandard) => {
                      if (lessonStandard.exists)
                        lesson.lessonStandard2 = lessonStandard.data();
                    });
                  }

                  semester.lessons.push(lesson);
                });
              });
              if (this.selectedSemester == null && semester) {
                this.selectedSemester = semester;
              }
              this.semesters.push(semester);
            });
          }
        });
    },
    _read() {},
  },
};
</script>
